// TODO: Navgation Event bus
// TODO: Close Event bus

import { on } from '../helpers/utils';
import cssClasses from '../helpers/cssClasses';

/**
 * DOM selectors.
 */
const selectors = {
  container: '[js-search="container"]',
  input: '[js-search="input"]',
  open: '[js-search="open"]',
  close: '[js-search="close"]',
};

/* ================= Search Popup ================= */
export default () => {

  const container = document.querySelector(selectors.container);
  const nodeSelectors = {
    input: container.querySelector(selectors.input),
    open: [...document.querySelectorAll(selectors.open)],
    close: [...document.querySelectorAll(selectors.close)],
  };

  function setEventListeners() {
    document.documentElement.addEventListener('keydown', handleKeydown);

    nodeSelectors.open.forEach((item) => {
      on('click', item, () => addActiveState(item));
    });

    nodeSelectors.close.forEach((item) => {
      on('click', item, () => removeActiveState(item));
    });
  }

  function addActiveState(item) {
    container.classList.add(cssClasses.active);
    nodeSelectors.input.focus();

    nodeSelectors.open.forEach((item) => {
      item.classList.remove(cssClasses.active);
    });

    nodeSelectors.close.forEach((item) => {
      item.classList.add(cssClasses.active);
    });
  }

  function removeActiveState(item) {
    container.classList.remove(cssClasses.active);

    nodeSelectors.open.forEach((item) => {
      item.classList.add(cssClasses.active);
    });

    nodeSelectors.close.forEach((item) => {
      item.classList.remove(cssClasses.active);
    });
  }


  function handleKeydown(ev) {
    if (ev.keyCode === 27) {
      removeActiveState();
    }
  }

  function init() {
    setEventListeners();
    removeActiveState();
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
    removeActiveState,
  });
};
